
// @ts-nocheck
import {
  toRefs,
  defineComponent,
  getCurrentInstance,
  onBeforeUnmount,
  reactive
} from 'vue'
import { useOption } from './useOption'
import { SelectOptionProxy } from './token'

export default defineComponent({
  name: 'MsOption',
  componentName: 'MsOption',

  props: {
    value: {
      required: true,
      type: [String, Number, Boolean, Object]
    },
    // eslint-disable-next-line vue/require-default-prop
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    inlineStyle: {
      type: String,
      default: ''
    }
  },

  setup (props) {
    const states = reactive({
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false
    })

    const {
      currentLabel,
      itemSelected,
      isDisabled,
      select,
      hoverItem
    } = useOption(props, states)

    const {
      visible,
      hover
    } = toRefs(states)
    const vm = getCurrentInstance()?.proxy

    if (select) {
      select.onOptionCreate(vm as SelectOptionProxy)
    }

    onBeforeUnmount(() => {
      if (select) {
        const { selected } = select

        const selectedOptions = select.props.multiple ? selected : [selected]
        const doesExist = select.cachedOptions.has(props.value)
        const doesSelected = selectedOptions.some((item: any) => {
          return item.value === (vm as unknown as SelectOptionProxy).value
        })
        // if option is not selected, remove it from cache
        if (doesExist && !doesSelected) {
          select.cachedOptions.delete(props.value)
        }
        select.onOptionDestroy(props.value as Record<string, any>)
      }
    })

    function selectOptionClick () {
      if (props.disabled !== true && states.groupDisabled !== true && select) {
        select.handleOptionSelect(vm, true)
      }
    }

    return {
      currentLabel,
      itemSelected,
      isDisabled,
      select,
      hoverItem,
      visible,
      hover,
      selectOptionClick
    }
  }
})

